import React, { useState } from "react";
import { IoIosInformationCircleOutline } from "react-icons/io";
import Input from "../../../../ui/Input/Input";
import Modal from "../../../../ui/Modal/Modal";
import "./Numeric.css";

function Numeric({ question, onUpdateAnswer, invalidKeys }) {
  const [answer, setAnswer] = useState("");
  const [modalVisible, setModalVisible] = useState(false);
  const isInvalid = invalidKeys.includes(question.key);

  function updateAnswerHandler(e) {
    let enteredValue = e.target.value;
    const cleanedValue = enteredValue.replace(/[^0-9]/g, "");
    const parsedValue = parseInt(cleanedValue, 10);
    if (!isNaN(parsedValue)) {
      setAnswer(parsedValue.toString());
      const answer = {
        key: question.key,
        answer: enteredValue,
        question: question.description,
        type: question.answersType,
        minValue: question.minValue,
        maxValue: question.maxValue,
      };
      onUpdateAnswer(answer);
    } else {
      setAnswer("");
    }
  }

  return (
    <>
      <Modal isOpen={modalVisible} onClose={() => setModalVisible(false)}>
        <div style={{
          backgroundColor: "",
        }}>
          {question.modalTexts &&
            question.modalTexts.map((t, i) => {
              return (
                <p
                  key={i}
                >
                  {t}
                </p>
              );
            })}
        </div>

      </Modal>
      <div className={isInvalid ? "error" : "mainNumeric"}>
        <IoIosInformationCircleOutline
          style={{ fontSize: "20px", padding: "8px", color: "white" }}
          onClick={() => { setModalVisible(true) }}
        />
        <Input
          label={question.description}
          onUpdateValue={updateAnswerHandler.bind(this)}
          value={answer}
          type="number"
          autoCompleteType="off"
        />
      </div>
    </>
  );
}

export default Numeric;
